import React, {  Component } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';

export default class RunReportDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            isTodayPriceChecked: true,
            isFuturePriceChecked: false,
            date: '',
        }
        this.onChangeUpdateParam = this.onChangeUpdateParam.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('RunReportDialog', false);
    }

    handleChange(date) {
     	var self = this;
       	self.setState({
     	  	date: date
       	});
    }

    handleContinue(event) {
		event.preventDefault();
        let self = this;
        let selecteDate = '';
        if(self.state.isTodayPriceChecked){
             selecteDate = moment().format('MM/DD/YYYY').toString();
        }else{
             selecteDate = self.state.date;
        }
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('RunReportDialog', false);
        this.props.handleContinueRunReport(self.state, selecteDate);
	}

    onChangeUpdateParam(paramName, event) {
         var self = this;        
             if(paramName === "futurePrice" && event.target.checked == true){
                self.setState({
                    isTodayPriceChecked: false,
                    isFuturePriceChecked: true,
                })
             }else{
                self.setState({
                    isFuturePriceChecked: false,
                    isTodayPriceChecked: true,
                })
             }
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="overlayDialogWindow">
                        <div>
                            <div>
                                <h2 className="title">Select price date for export</h2>
                                <label>
                                    <input type="radio" name="showPriceDate" id="showTodaysPrice" checked={this.state.isTodayPriceChecked} onClick={this.onChangeUpdateParam.bind(this, "todaysPrice")} defaultValue="todaysPrice" /> Today&#39;s Price
                                </label>
                                <br/><br/><br/>
                                <label>
                                    <input type="radio" name="showPriceDate" id="showFuturePrice" checked={this.state.isFuturePriceChecked} onClick={this.onChangeUpdateParam.bind(this, "futurePrice")} defaultValue="futurePrice" />Future Price <i>(date must be within 30 days)</i>
                                </label>
                                <br/><br/>
                                <DatePicker minDate={moment()} maxDate={moment().add(30, "days")} onKeyDown={(e) => {e.preventDefault();}} disabled={!this.state.isFuturePriceChecked} placeholderText="(mm/dd/yyyy)" selected={this.state.date} onChange={this.handleChange.bind(this)} />
                                    
                             </div>
                        </div>
                        <div className="noButtonContainer">
                            <a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                        </div>
                        <div className="yesButtonContainer">
                            <a className="yesButton blueButton" onClick={this.handleContinue.bind(this)}>Continue</a>
                        </div>
                    </div>
             </div>
            
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/runReportDialog.js